import React from 'react';
import { ILandingPageBuilderBulkEditFormData } from '../../../helpers/getInitialLandingPageValuesForBulkEdit';
import { FormSection } from '../../form/shared/FormSection';
import { ChangesSummarySection } from '../../../hooks/useChangesSummaryMapper';

interface IChangedFieldsSectionProps {
  fields: JSX.Element[];
  section: ChangesSummarySection;
  values: ILandingPageBuilderBulkEditFormData;
}

export const ChangedFieldsSection = ({
  fields,
  section,
}: IChangedFieldsSectionProps) => {
  return (
    <FormSection key={section.title} title={section.title}>
      {fields.map((field: JSX.Element) => field)}
    </FormSection>
  );
};
